// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1t4B8","header":"ReportDetails_header__XQiEL","title":"ReportDetails_title__3mpPv","left":"ReportDetails_left__WJyuL"};